<template>
	<div>
		<v-card flat>
			<slot name="heading"> </slot>
			<v-data-table :headers="headers" :items="hrDocuments" hide-actions class="elevation-1" disable-initial-sort>
				<template slot="items" slot-scope="props">
					<tr style="height: 64px">
						<td style="width: 1px">
							<v-list-tile-avatar style="display: inline; width: 32px; height: 32px" class="mr-3">
								<v-icon class="error white--text">assignment_late</v-icon>
							</v-list-tile-avatar>
						</td>
						<td class="text-xs-left">
							<v-layout row>
								<v-flex style="align-self: center">
									<a href="#" @click.stop.prevent="loadHrDocumentDialog(props.item.hrDocumentId, props.item.name)">{{ props.item.name }}</a>
								</v-flex>
							</v-layout>
						</td>

						<td style="width: 1px">{{ props.item.versionNo }}</td>
						<td class="text-xs-left" v-if="!hideLastUpdated">
							<AppDate :date="getLastUpdated(props.item)" :key="newGuid()" show-date format="Do MMM YYYY, HH:mm" />
						</td>
						<td v-if="isLoggedInEmployee" style="width: 1px">
							<v-btn color="primary" small @click="loadHrDocumentDialog(props.item.hrDocumentId, props.item.name)">Acknowledge</v-btn>
						</td>
					</tr>
				</template>
			</v-data-table>
		</v-card>

		<hr-document-dialog :id="hrDocumentDialogId" :dialog="showHrDocumentDialog" :title="hrDocumentDialogTitle" @closeDialog="onCloseDialog" @onAcknowledged="onAcknowledged" />
	</div>
</template>

<script>
	import HrDocumentDialog from '@/components/hrDocuments/HrDocumentDialog';

	export default {
		components: {
			HrDocumentDialog
		},
		props: {
			title: {
				type: String,
				default: 'Unacknowledged HR Documents'
			},
			hrDocuments: {
				type: Array,
				required: true
			},
			isLoggedInEmployee: {
				type: Boolean
			},
			hideLastUpdated: {
				type: Boolean
			}
		},
		data() {
			return {
				search: null,
				headers: [
                    { text: '', value: ''},
					{ text: 'Policy Name', value: 'name' },
					{ text: 'Version', value: 'version' }
				],
				showHrDocumentDialog: false,
				hrDocumentDialogId: null,
				hrDocumentDialogTitle: null
			};
		},
		created() {
			if (!this.hideLastUpdated) {
				this.headers.push({ text: 'Last Updated', value: 'lastUpdatedDateUtc', sortable: false });
			}
			if (this.isLoggedInEmployee) {
				this.headers.push({ text: '', value: 'actions', sortable: false });
			}
		},
		methods: {
			viewDocument(hrDocumentId) {
				this.$router.push(`/hrDocuments/${hrDocumentId}`);
			},
			getLastUpdated(hrDocument) {
				return hrDocument.lastUpdatedDateUtc != null ? hrDocument.lastUpdatedDateUtc : hrDocument.createdDateUtc;
			},
			loadHrDocumentDialog(hrDocumentId, hrDocumentTitle) {
				this.showHrDocumentDialog = true;
				this.hrDocumentDialogId = hrDocumentId;
				this.hrDocumentDialogTitle = hrDocumentTitle;
			},
			onCloseDialog() {
				this.showHrDocumentDialog = false;
				this.hrDocumentDialogId = null;
				this.hrDocumentDialogTitle = null;
			},
			onAcknowledged() {
				this.$emit('onUpdated', 'You have successfully acknowledged the contents of policy');
				this.onCloseDialog();
			}
		}
	};
</script>

<style scoped>
	.info-text {
		color: rgba(0, 0, 0, 0.54);
		font-size: 12px;
	}
</style>
